import React, { useContext, useEffect } from "react";
import { ReactComponent as IconeDominio } from "../../assets/newImages/compartilhar/dominio.svg";
import LockedIcon from "../../components/LockedIcon/LockedIcon";
import { AuthContext } from "../../contexts/Auth/AuthContext";

interface ConfigurarDominioProps {
  dominio: any;
  empresa: any;
}

const ConfigurarDominio: React.FC<ConfigurarDominioProps> = ({
  dominio,
  empresa,
}) => {
  let dominio_configurado = verificaDominio();

  const { permissoesPlanos } = useContext(AuthContext);
  const [permitidoDominio, setPermitidoDominio] = React.useState(false);

  useEffect(() => {
    if (
      permissoesPlanos &&
      !permissoesPlanos["DOMINIO_PROPRIO"]?.permitido
    ) {
      setPermitidoDominio(false);
    } else {
      setPermitidoDominio(true);
    }
  }, [permissoesPlanos]);

  function verificaDominio() {
    if (
      dominio.includes("shop") ||
      (!dominio.includes("app") && !dominio.includes("localhost"))
    ) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <div className="baixo">
      <div className="texto">
        <div className={`titulo-container fonteTitulo ${!permitidoDominio ? "bloqueado" : ""}`}>
          {dominio_configurado
            ? "Domínio configurado"
            : "Configure seu domínio próprio"}
          {!permitidoDominio && <LockedIcon mensagem="Recurso disponível no plano Pofissional" width="15px" className="icone-bloqueado" />}
        </div>
        <span>
          {dominio_configurado ? (
            <span>{dominio}</span>
          ) : (
            <span className={`fonteTexto ${!permitidoDominio ? "bloqueado" : ""}`}>www.suamarca.com.br</span>
          )}
        </span>
        <div className="configuracoes">
          <a
            href={`https://api.whatsapp.com/send?phone=555434434563&text=Ol%C3%A1,+gostaria+de+configurar+meu+dom%C3%ADnio+pr%C3%B3prio+no+Conecta+Venda.+Meu+usu%C3%A1rio+%C3%A9:+${empresa?.usuario}+da+empresa:+${empresa?.empresa}.`}
            target="_blank"
            className="botao fonteTexto"
          >
            {dominio_configurado ? "Alterar domínio" : "Falar com atendimento"}
          </a>
        </div>
      </div>
      <IconeDominio />
    </div>
  );
};

export default ConfigurarDominio;
